import { makeStyles } from '@mui/styles'
import classNames from 'classnames'
import {
  AAHASimple as AAHASimpleIcon,
  AddNote as AddNoteIcon,
  Analytics as AnalyticsIcon,
  ChewySubmark as OmniChannelIcon,
  MobilePhone as MobilePhoneIcon,
  Pim as PimIcon,
  WellnessClear as WellnessClearIcon,
} from '@pbt/pbt-ui-components/src/icons'

import { BusinessTypeName } from '~/constants/businesses'

const BUSINESS_TYPE_NAMES = new Set<string>(Object.values(BusinessTypeName))

function isBusinessTypeName(value: string): value is BusinessTypeName {
  return BUSINESS_TYPE_NAMES.has(value)
}

export const BusinessTypeLabelIcon = {
  [BusinessTypeName.AAHA]: AAHASimpleIcon,
  [BusinessTypeName.ANALYTICS]: AnalyticsIcon,
  [BusinessTypeName.PHONE]: MobilePhoneIcon,
  [BusinessTypeName.PIMS]: PimIcon,
  [BusinessTypeName.WELLNESS]: WellnessClearIcon,
  [BusinessTypeName.OMNICHANNEL]: OmniChannelIcon,
  [BusinessTypeName.CVC]: AddNoteIcon,
} satisfies Partial<Record<BusinessTypeName, typeof AddNoteIcon>>

const useStyles = makeStyles(
  (theme) => ({
    root: {
      color: theme.colors.signIconBackground,
    },
  }),
  { name: 'BusinessTypeIcon' },
)

export interface BusinessTypeIconProps {
  className?: string
  iconName?: string
}

const BusinessTypeIcon = ({ iconName, className }: BusinessTypeIconProps) => {
  const classes = useStyles()

  const IconComponent =
    iconName && isBusinessTypeName(iconName)
      ? (BusinessTypeLabelIcon[iconName] ?? AddNoteIcon)
      : AddNoteIcon

  return <IconComponent className={classNames(classes.root, className)} />
}

export default BusinessTypeIcon
